import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  filtersContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  },
  halfSizeField: {
    width: '48%'
  },
  accFieldFilter: {
    width: '100%',
    marginBottom: -6
  },
  searchField: {
    flex: 1,
    margin: '0px 40px'
  },
  itemsBox: {
    paddingLeft: 20,
    paddingRight: 0,
    paddingTop: 10,
    paddingBottom: 16,
    marginBottom: 20,
    marginTop: 20,
    border: '1px solid #e7e7e7',
    borderRadius: 16,
    height: 'calc(100vh - 550px)',
    minHeight: 350,
    position: 'relative'
  },
  listView: {
    height: '100%',
    overflowY: 'auto'
  },
  itemsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(3, 1fr)'
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(4, 1fr)'
    },
    gap: 12,
    paddingTop: 16,
    paddingRight: 20
  },
  title: {
    marginBottom: 20,
    marginTop: 30,
    paddingBottom: 5,
    position: 'relative',
    width: 'fit-content'
  },
  submitFormBox: {
    position: 'absolute',
    width: '80%',
    left: '10%',
    borderRadius: 24,
    padding: 24,
    bottom: 20,
    display: 'grid',
    gridTemplateColumns: '1fr'
  },
  accHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& h2': {
      marginTop: 0
    },
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
      gridTemplateColumns: '4fr 1fr'
    }
  },
  accHeaderButtons: {
    paddingRight: 16,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      '& button': {
        padding: 6
      }
    }
  },
  searchInput: {
    marginBottom: 20
  },
  bottonsPositionSolver: {
    width: '100%',
    height: '44vh'
  },
  CircularProgress: {
    margin: '100px 0px 100px calc(50% - 20px)',
    [theme.breakpoints.up('sm')]: {
      margin: '70px 0px 70px calc(50% - 20px)'
    }
  },
  mainSkeleton: {
    borderRadius: '10px'
  },
  skeletonContainer: {
    paddingTop: '46%'
  },
  mainInput: {
    marginTop: '25px'
  }
}))

export default useStyles
